import useAPI from '@/hooks/useAPI';
import PersonPersonRelationshipRepository from '@/repositories/PersonPersonRelationshipRepository';
import { QueryParams } from '@/types/query';

export const usePersonPersonRelationships = (params: QueryParams) => {
  const personPersonRelationshipsRepository = PersonPersonRelationshipRepository();

  return useAPI({
    queryKey: ['getPersonPersonRelationships', params],
    queryFn: () => personPersonRelationshipsRepository.getPersonPersonRelationships(params),
    enabled: !!params
  });
};

export const usePersonPersonRelationshipTypes = (
  params: QueryParams = {},
  enabled: boolean = true
) => {
  const personPersonRelationshipsRepository = PersonPersonRelationshipRepository();

  return useAPI({
    queryKey: ['getPersonPersonRelationshipTypes', params],
    queryFn: () => personPersonRelationshipsRepository.getPersonPersonRelationshipTypes(params),
    enabled
  });
};
